import { FormHelperText, styled } from '@mui/material';
import { ReactNode } from 'react';

export type FieldContainerProps = {
  children: ReactNode;
  direction?: 'horizontal';
  errorMessage?: string;
  className?: string;
};

const StyledFieldContainer = styled('div')<{
  direction?: 'horizontal' | 'vertical';
}>(({ theme, direction }) => ({
  width: '100%',
  gap: direction === 'horizontal' ? theme.spacing(2) : theme.spacing(6),
  display: direction === 'horizontal' ? 'flex' : 'block',
  alignItems: 'center',
  position: 'relative',
  textAlign: 'left',
  '& fieldset': {
    border: 'none',
  },
}));

export const FieldContainer = ({
  children,
  direction,
  errorMessage,
  className
}: FieldContainerProps) => {
  return (
    <div>
      <StyledFieldContainer className={className} direction={direction}>
        {children}
      </StyledFieldContainer>
      {errorMessage ? (
        <FormHelperText error>{errorMessage}</FormHelperText>
      ) : null}
    </div>
  );
};
